import { defineStore } from "pinia";
import { useRouter } from "vue-router";
interface UserInfo {
  tenantId?: string;
  mobile: string;
  userName: string;
  userId: string;
  userHeadImage: string;
  [key: string]: any;
}

interface UserState {
  token: string;
  userInfo: UserInfo;
}

export const userStore = defineStore({
  id: "user",
  persist: true,
  state: (): UserState => ({
    token: "",
    userInfo: {
      mobile: "",
      userName: "",
      userId: "",
      userHeadImage: "",
    },
  }),
  getters: {
    getToken(): string {
      return this.token;
    },
    isLogin(): boolean {
      return !!this.token;
    },
  },

  actions: {
    login(data: any) {
      console.log("login");
      const { token } = data;
      this.setToken(token);
      this.setUserInfo(data);
    },
    setToken(token: string) {
      this.token = token;
      localStorage.setItem("token", token);
    },
    setUserInfo(userInfo: any) {
      this.userInfo = userInfo;
    },
    loginOut() {
      this.$reset();
    },
    updateUserInfo(data: any) {
      Object.assign(this.userInfo, data);
    },
  },
});
